import BaseEntity from "./BaseEntity";

export default class AuxOrganization extends BaseEntity {
  Name = "";
  StreetAddress = "";
  City = "";
  Region = "";
  PostalCode = "";
}
